import(/* webpackMode: "eager" */ "/codebuild/output/src4271355797/src/app/home/page.tsx");
